import { useState } from "react";
import "./RateForm.scss";
import { FaCamera, FaTimes } from "react-icons/fa";
import StarReview from "./StarReview";

export default function RateForm({ onClose, handleRate }) {
  const [review, setReview] = useState("");
  const [selectedStar, setSelectedStar] = useState(0);
  const [selectedFiles, setSelectedFiles] = useState([]); // multiple files
  const [previews, setPreviews] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    // Separate images and videos from current uploads
    const existingImages = selectedFiles.filter((f) =>
      f.type.startsWith("image/")
    );
    const existingVideos = selectedFiles.filter((f) =>
      f.type.startsWith("video/")
    );

    // Separate new uploads
    const newImages = files.filter((f) => f.type.startsWith("image/"));
    const newVideos = files.filter((f) => f.type.startsWith("video/"));

    // Check limits
    if (existingImages.length + newImages.length > 3) {
      alert("You can only upload up to 3 images.");
      return;
    }
    if (existingVideos.length + newVideos.length > 3) {
      alert("You can only upload up to 3 videos.");
      return;
    }

    const validFiles = [...newImages, ...newVideos];

    setSelectedFiles((prev) => [...prev, ...validFiles]);

    const newPreviews = validFiles.map((file) => ({
      type: file.type,
      url: URL.createObjectURL(file),
    }));

    setPreviews((prev) => [...prev, ...newPreviews]);
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    setPreviews((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (selectedStar === 0) {
      alert("Please select a star rating.");
      return;
    }

    setIsUploading(true);
    try {
      await handleRate(selectedStar, review, selectedFiles);
      onClose();
    } catch (err) {
      // handled outside
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="cancelform-container">
      <h2>RATE OUR PRODUCT!</h2>

      <div className="star-container">
        <StarReview
          setSelectedStar={setSelectedStar}
          selectedStar={selectedStar}
        />
      </div>

      <span>Write a review: (Optional)</span>
      <div className="rate-other-wrapper">
        <textarea
          value={review}
          onChange={(e) => setReview(e.target.value)}
          placeholder="Share your thoughts about this product..."
        />
      </div>

      <div
        className={`rate-upload-panel-wrapper ${
          previews.length > 0 ? "hasUpload" : ""
        }`}
      >
        {previews.length > 0 && (
          <div className="preview-wrapper">
            {previews.map((file, index) => (
              <div key={index} className="preview-item">
                {file.type.startsWith("image/") ? (
                  <img src={file.url} alt={`preview-${index}`} />
                ) : (
                  <video
                    src={file.url}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    disablePictureInPicture
                  />
                )}
                <button
                  className="remove-btn"
                  onClick={() => handleRemoveFile(index)}
                  title="Remove"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}

        <label className="upload-btn">
          <input
            type="file"
            accept="image/png, image/jpeg, image/jpg, video/mp4, video/mov"
            multiple
            onChange={handleFileChange}
            hidden
          />
          <span>
            <FaCamera />
          </span>
          ADD PHOTO/VIDEO
        </label>

        <span>Allowed: .JPG .JPEG .PNG (max 3) / .MP4 .MOV (max 2)</span>
      </div>
      <div className="button-wrapper">
        <button className="cancel" onClick={onClose} disabled={isUploading}>
          Cancel
        </button>

        <button
          className="submit"
          onClick={handleSubmit}
          disabled={isUploading}
        >
          {isUploading ? "Uploading..." : "Submit"}
        </button>
      </div>
    </div>
  );
}
